module.exports = __webpack_public_path__ + "static/img/nengxiao.bc67118c.png";